/**
 * <s-countdown data-end="ISO date"> — live countdown to data-end.
 * Writes into [data-days], [data-hours], [data-minutes], [data-seconds] children.
 * When the end time passes, hides the closest [data-countdown-scope] (or itself).
 * Updates once a second and stops while the tab is hidden.
 */
class SCountdown extends HTMLElement {
  connectedCallback() {
    this.end = Date.parse(this.dataset.end);
    if (Number.isNaN(this.end)) return;
    this.parts = {
      days: this.querySelector('[data-days]'),
      hours: this.querySelector('[data-hours]'),
      minutes: this.querySelector('[data-minutes]'),
      seconds: this.querySelector('[data-seconds]'),
    };
    this.tick = this.tick.bind(this);
    this.tick();
    this.timer = setInterval(this.tick, 1000);
  }

  disconnectedCallback() {
    clearInterval(this.timer);
  }

  tick() {
    if (document.hidden) return;
    const remaining = this.end - Date.now();
    if (remaining <= 0) {
      clearInterval(this.timer);
      const scope = this.closest('[data-countdown-scope]') || this;
      scope.hidden = true;
      return;
    }
    const total = Math.floor(remaining / 1000);
    const values = {
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
    for (const [key, el] of Object.entries(this.parts)) {
      if (!el) continue;
      const text = key === 'days' ? String(values[key]) : String(values[key]).padStart(2, '0');
      if (el.textContent !== text) el.textContent = text;
    }
    this.removeAttribute('hidden');
  }
}

if (!customElements.get('s-countdown')) customElements.define('s-countdown', SCountdown);
